import React from 'react';
import styled from 'styled-components';

import { Tooltip } from '@common/Tooltip';
import { ReportGmailerrorredOutlined } from '@mui/icons-material';

export const NodeContainer = styled.div<{ selected?: boolean; error?: boolean; nodeOutline: string }>`
  width: 100%;
  height: 100%;
  /* opacity: ${({ theme }) => theme.opacity}; */
  color: ${({ theme }) => theme.text.standard};
  border-radius: 12px;
  background: ${({ theme }) => theme.background.node};
  border: ${({ selected, theme }) =>
    selected ? `1px solid ${theme.background.primary}` : `1px solid ${theme.line.standard}`};
  outline: ${({ nodeOutline }) => nodeOutline};

  /* 
  &::after {
    content: '';
    position: absolute;
    top: -3px;
    left: -4px;
    right: -5px;
    bottom: -3px;
    border-radius: 16px; 
    background: ${({ theme }) =>
    `conic-gradient(from -160deg at 50% 50%, ${theme.telnyx.green} 0deg, ${theme.telnyx.blue} 180deg, ${theme.telnyx.green} 360deg)`};
    z-index: -1;

    background: ${({ selected, theme }) =>
    selected &&
    `conic-gradient(from -160deg at 50% 50%,${theme.telnyx.green} 0deg,
          ${theme.telnyx.blue} 180deg,
          rgba(52, 52, 239, 0) 360deg)`};

    ${({ selected }) => selected && `animation: {spinner} 4s linear infinite;`};
  } */
`;

export const NodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NodeErrorToolbar: React.FC<{ error?: string | null }> = ({ error }) => {
  return (
    <NotificationContainer color='#f35c5c'>
      <Tooltip
        placement='top'
        arrow
        sx={{ maxWidth: '300px' }}
        title={error || 'An unexpected error occured while executing this node.'}
      >
        <Notification>
          <NotificationIcon>
            <ReportGmailerrorredOutlined sx={{ fontSize: '2.5ch' }} />
          </NotificationIcon>
          <h1>Node Error</h1>
        </Notification>
      </Tooltip>
    </NotificationContainer>
  );
};

export const NodeNotifications = styled.div`
  display: flex;
  position: absolute;
  top: -40px;
  width: 100%;
  justify-content: center;
  margin-bottom: 12px;
`;

export const NotificationContainer = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.background.standard};
  border: 1px solid ${({ theme }) => theme.line.light};
  box-shadow: ${({ theme, color }) => `0px 3px 3px -1px ${color || theme.telnyx.yellow}`};
  border-radius: 8px;
  padding: 2px 8px;
  gap: 2px;
`;

export const Notification = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  padding: 2px 0;
  padding-right: 2px;
  gap: 6px;

  color: ${({ theme, color }) => color || theme.telnyx.red};

  svg {
    color: ${({ theme, color }) => color || theme.telnyx.red};
  }

  h1 {
    font-size: 12px;
    font-weight: 500;
    margin: 0;
  }

  p {
    font-size: 9px;
    font-weight: 400;
    margin: 0;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const NotificationIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text.standard};

  width: 14px;

  svg {
    font-size: 15px;
  }
`;

export const NodeProgressBar = styled.div`
  position: absolute;
  top: -7px;
  left: 50%;
  transform: translateX(-55%);
  width: 95%; // Adjust width as needed

  & .MuiLinearProgress-root {
    width: 100%;
    height: 2.5px;
    color: ${({ theme }) => theme.telnyx.green};
    background-color: transparent;
  }

  /* .css-1mn37of-MuiLinearProgress-bar1 {
    background-color: ${({ theme }) => theme.telnyx.green} !important;
  }

  .css-z048lh-MuiLinearProgress-bar2 {
    background-color: ${({ theme }) => theme.telnyx.green} !important;
  } */
`;
